// @flow
import * as React from 'react';
import { PropsWithChildren } from 'react';
import { styled, ThemeProvider } from '@mui/material';
import { SnackbarProvider, MaterialDesignContent } from 'notistack';
import { AppStateContextProvider } from '@coverright/shared/contexts';
import { environment } from '../../environments/environment';
import { medicareAiTheme } from '@coverright/ui/themes';
import { KeycloakProvider } from '@coverright/shared/keycloak';
import { AiProvider, DoctorsDrugsModalProvider, ScoringProvider, useMedicareQuote } from '../shared';
import { PlanSelectionProvider } from '../pages/plans/shared/plan-selection/plan-selection-context';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#6CE9B8',
    color: '#044333',
    fontWeight: 600,
    boxShadow: 'none',
    minWidth: 0,
    borderRadius: '8px',
  },
}));

export function Providers({ children }: PropsWithChildren) {
  const quote = useMedicareQuote();
  return (
    <KeycloakProvider lateInit>
      <ThemeProvider theme={medicareAiTheme}>
        <SnackbarProvider
          preventDuplicate
          Components={{
            success: StyledMaterialDesignContent,
            error: StyledMaterialDesignContent,
          }}
          anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
          autoHideDuration={6000}
          maxSnack={3}
        >
          <AppStateContextProvider userFlowRestUrl={environment.userFlowRestUrl} quoteId={quote?.id}>
            <ScoringProvider>
              <AiProvider>
                <PlanSelectionProvider>
                  <DoctorsDrugsModalProvider>
                    {children}
                  </DoctorsDrugsModalProvider>
                </PlanSelectionProvider>
              </AiProvider>
            </ScoringProvider>
          </AppStateContextProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </KeycloakProvider>
  );
}
